
import { Component, Watch } from 'vue-property-decorator';

import Booking from '@/views/Booking.vue';

import { findColor } from '@/config/functions';
import { forEach } from 'lodash';

@Component({
   computed: {
      is_archive() {
         // @ts-ignore
         return ['true', true, 1, '1'].includes(this.$route?.query['archive']);
      },
   },
})
export default class ListPage extends Booking {
   is_archive!: boolean;

   unfiltered: any[] = [];

   filtered: any[] = [];

   filter: any = {};

   @Watch('filter', { deep: true })
   filterData() {
      this.filtered = this.unfiltered.filter((a: any) => {
         const filtered: any = {};

         forEach(this.filter, (v: any, f: string) => {
            if (typeof a[f] == 'undefined' || Object.keys(filtered).includes(f)) return;

            let value = a[f];

            if (f == 'o_average_gp') {
               value = value < a['o_minimum_gp'] ? a['o_minimum_gp'] : value;
            }

            if (f == 'o_new_average_gp') {
               value = value < a['o_new_minimum'] ? a['o_new_minimum'] : value;
            }

            if (Array.isArray(v) && v.length) {
               const is_date = v.map(c => this.$moment(c).isValid()).filter(d => d).length == v.length;
               if (is_date) {
                  filtered[f] = this.$moment(value).isValid() ? this.$moment(value).isBetween(v[0], v[1]) : false;
                  return;
               }
            }

            if (typeof v == 'number' && typeof value == 'number') {
               v = this.formatterFloat(v);
               value = this.formatterFloat(value);
            }

            if (f.includes('_status') || f.includes('_color')) {
               //console.log(v, a[f]);
               filtered[f] = !v.length || findColor(v, value, this.default_colors[f], this.activities_colors);
               return;
            }

            if (([0, 1].includes(v) && [0, 1].includes(value)) || (typeof v == 'boolean' && typeof value == 'boolean')) {
               filtered[f] = value === v;
               return;
            }

            filtered[f] = v === '' || this.stripos(value, v);
         });

         //console.log(filtered, Object.keys(filtered).length == Object.values(filtered).filter(f => f).length);

         return Object.keys(filtered).length == Object.values(filtered).filter(f => f).length;
      });
   }

   @Watch('unfiltered', { deep: true })
   changeTasks() {
      this.filterData();
   }
}
